module.exports = __webpack_public_path__ + "img/会商设备.1c4646d4.gif";